<template>
  <v-card elevation="3" class="login-form-card">
    <form class="login-form" style="display: flex; flex-direction: column; justify-content: space-evenly; align-items: center">
      <v-img
          id="latLogo"
          width="250px"
          height="auto"
          contain
          alt="Lufthansa Aviation Training"
          src="@/assets/images/lat_logo.png"
      />
      <v-text-field
          style="width: 100%"
          v-model="name"
          label="Choose a username"
      ></v-text-field>
      <v-btn
          style="margin-top: 1em; width: max-content;"
          color="primary"
          class="mr-4"
          @click="submit"
      >
          <span style="white-space: normal">
           Start Application Prototype
          </span>
      </v-btn>
    </form>
  </v-card>
</template>

<script>

export default {
  name: "LoginForm",
  data: () => ({
    name: ""
  }),
  methods: {
    submit() {
      this.$store.dispatch('saveUser', !this.name.trim() ? 'Cpt. Balu' : this.name)
      this.$router.push('/cockpits')
    },
  },
  mounted() {
    this.$store.dispatch('logOut')
  }
}

</script>

<style scoped>

.login-form-card {
}

.login-form {
  padding: 2.5em;
  height: 100%;
}
</style>